import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLanguage } from '../../context/LanguageContext';
import './style.scss';

const SCROLL_THRESHOLD = 300;

const ScrollToTop = () => {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      setVisible(scrollTop > SCROLL_THRESHOLD);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (typeof document === 'undefined') {
    return null;
  }

  return ReactDOM.createPortal(
    <button
      type="button"
      className={`scroll-to-top${visible ? ' scroll-to-top--visible' : ''}`}
      onClick={scrollToTop}
      aria-label={t('scrollToTop.label')}
      title={t('scrollToTop.label')}
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}
    >
      <FontAwesomeIcon icon={faChevronUp} />
    </button>,
    document.body
  );
};

export default ScrollToTop;
